module.exports = __webpack_public_path__ + "2acb60f2/img/arrow-left-icon.785c715c.svg";